import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = ({ text, active, onClick, large }) => {
  return (
    <Root className={active && 'active'} onClick={onClick} large={large}>
      <p>{text}</p>
    </Root>
  );
};

Button.propTypes = {
  text: PropTypes.any,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  large: PropTypes.bool,
};

const Root = styled.div`
	border: 1px solid #0B1A27;
	background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.large ? '200px' : '76px'};
  height: 38px;
  margin: 10px;
  cursor: pointer;
  > p {
    color: #0B1A27;
    font-family: "DINOT";
    font-size: 12px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
    text-transform: uppercase;
    transition: all 0.15s ease-out;
  }

  &.active, &:hover {
    box-sizing: border-box;
    border: 1px solid #FF7802;
    background-color: #FFFFFF;
    box-shadow: 0 0 8px 0 rgba(255,120,2,0.55);
    > p {
      font-size: 14px;
      color: #FF7802;
    }
  }

`;

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js